// extracted by mini-css-extract-plugin
module.exports = {"fieldLabel":"_1xVIFltEABzI7hVM9BCxh4","fieldValue":"_2-bowsmqKhaCpJFGBecH","cell":"_1EG7-FnXHOJefeHU-0ilo6","title":"_2T_5rpxEj5-c1tvnaOCMh3","table":"_2jTQ_wuURX2SyckK3Hnaau"};